import {ToolExecuteParams} from 'common/src/modules/shared/copilot/copilot.types';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import {z} from 'zod';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import getCardFromState from '../../utils/cardStateStorage/getCardFromState';
import setCardInState from '../../utils/cardStateStorage/setCardInState';
import {V2CardAgentToolName} from '../../promptToCardAgentV2.enums';

const setCardNameInputSchema = z.object({
  newName: z.string().describe('The new name of the card'),
});

export default function setCardNameTool() {
  async function execute(params: ToolExecuteParams<typeof setCardNameInputSchema>) {
    const {newName} = params.input;

    const card = getCardFromState();

    card.name = newName;

    setCardInState(card);

    return toolResult('Card renamed successfully');
  }

  return tool({
    name: V2CardAgentToolName.SetCardName,
    description: 'Set the name of the current card',
    displayName: 'Setting card name',
    inputSchema: setCardNameInputSchema,
    execute,
  });
}
